/* eslint no-undef: 0 */
import React from 'react'
import { observable, action } from 'mobx'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import Validators from '../validators'
import createSubentityConfs from './subentity'
import { BaseManipStateFn, BaseTableState } from '../base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    //
    requiredOptions = [
      'ContractCurrency',
      'ContractItemCategory',
      'ContractItemStatus',
      'ContractPaymentsStatus', // for contract payments
      'ContractPricingTier',
      'ContractTypes',
      'Countries', // for regions
      'ExpenseTypes',
      'Platforms',
      'RightsTypes',
      'UploadTypes',
      linkConst.LOAD_OPTIONS.clients,
      linkConst.LOAD_OPTIONS.constantsList,
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.films,
      linkConst.LOAD_OPTIONS.timeRestrictions
    ]

    @action onContractItemsLoaded (res) {
      this.contractitems = res.data
    }

    onLoaded (entity) {
      // load contract items as well
      store.requester.call(`/contractitems?filter={"contract_id":"${entity.id}"}`)
        .then(this.onContractItemsLoaded.bind(this))
        .catch(store.onRequesterError.bind(store))
      // create title for edit view
      try {
        this.edittitle = (
          <span>
            {this.edittitle}
            <span className='text-primary text-strong'> {entity && entity.name} </span>
            {defaultConst.TITLE_DIVIDER}
            {store.__(defaultConst.TITLE_EDIT)}
          </span>)
      } catch (e) {
        console.log(e)
      }

      super.onLoaded(entity)
    }

    beforeSave (entity) {
      // trim all necesary values
      entity.name = entity.name ? entity.name.trim() : null
      super.beforeSave(entity)
    }

    prepareNew () {
      // NOTE: here all contract's subentity arrays MUST be initialized
      this.record.set('contract_mgs', [])
      this.record.set('contract_payments', [])
      this.record.set('costs', [])
      this.record.set('rightsCosts', [])
      this.record.set('shares', [])
    }

    onSaved (saved) {
      const isUpdated = this.subentities && this.subentities.contract_payments &&
        this.subentities.contract_payments.edited && this.subentities.contract_payments.edited.updated
      // call procedure if "contract_payments" updated
      if (saved.id &&isUpdated) {
        store.requester
        .call('/contracts/call/update_contract_payments?contract_id=' + parseInt(saved.id), 'get')
        .then(result => {
          store.addMessage(store.__('Call to "after save" procedure (update_contract_payments) launched successfully'), 'success')
        })
        .catch(error => {
          store.addMessage(store.__('Call to "after save" procedure (update_contract_payments) terminated with error'), 'error')
        })
      }

      store.markDirty('contracts')
      store.markDirty('contractitems')
      super.onSaved(saved)
    }

    createtitle = store.__(linkConst.LINK_CONTRACTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_CONTRACTS_TITLE).concat(defaultConst.TITLE_DIVIDER)
    subentities = createSubentityConfs(store)
    _sortField = linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACTS]._sortField
    _sortDir = linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACTS]._sortDir
    @observable contractitems = []
    @observable timeoutDisabled = false
    selectedTab = 1
    selectedTabClients = 1
    validators = {
      name: [
        Validators.isMandatory(store),
        Validators.maxLength(store, 128)
      ],
      autorenewal_license_period_months: Validators.positiveInt(store),
      shares: (val) => {
        if (val === undefined || val.length === 0) {
          return
        }
        const temp = []
        val.map(o => {
          const key = o.right_type + o.platform + (o.source_of_revenues_cd || '')
          temp[key]
            ? temp[key] += parseFloat(o.share)
            : temp[key] = parseFloat(o.share)
        })
        var condition = true
        for (const t in temp) {
          if (temp[t] !== 100) {
            condition = false
          }
        }
        if (!condition) {
          return store.__('Total shares for each Platform/Right type (or with Limited to source of revenues) must be 100%.')
        }
      },
      _global: (vals) => {
        const findContractByType = type =>
          store.options.get('contracts').find(c =>
            c.contract_type === type &&
            c.name === vals.get('name') &&
            c.id != vals.get('id'))

        // //> if contract_type "purchase" is set and contract has been already purchased
        // if (vals.get('contract_type')
        //     && vals.get('contract_type') === 'purchase'
        //     && findContractByType(vals.get('contract_type')))
        //     return [store.__('Contract has been already purchased')]

        // > if contract type is set and its not "purchase"
        // currently no validations performed
        // if(vals.get('contract_type') /*&& vals.get('contract_type') !== 'purchase'*/) {
        //   let chained = () => {
        //     let chain = ["purchase", "sale", "resale"]
        //     return chain.slice(0, chain.indexOf(vals.get('contract_type'))).map(i => findContractByType(i)).every(i => i)
        //   }
        //
        //   if(!chained())
        //     return [store.__('Contracts have to be in contract type chain')]
        // }
      }
    }

    onFieldChange = {
      parent_id: (val, state) => {
        if (val) {
          // load parent detail
          store.requester.call(`/contracts/${val}`)
            .then(({ data }) => {
              ['currency', 'payment_minimum_limit', 'payment_wire_fee', 'payment_iban', 'payment_swift', 'payment_account_number', 'payment_account_detail']
                .map(i => {
                  store.cv.record.set(i, data[i])
                })
              store.addMessage(store.__('Parent contract data loaded'), 'info')
            })
            .catch(store.onRequesterError.bind(store))
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'name', 'contract_type', 'contract_date', 'contract_end_date'
    ]

    headertitles = [
      store.__('ID'), store.__('name'), store.__('contract type'), store.__('begin date'), store.__('end date')
    ]

    requiredOptions = [
      'ContractTypes'
    ]

    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACTS]
    title = store.__(linkConst.LINK_CONTRACTS_TITLE)
  }

  return { ManipState, TableState }
}
